import { CardActions, Chip, Stack } from "@mui/material"
import { NexCard, NexCardActionButton, NexCardContent } from "../../components/NexCard"
import { Body, BoldBody, Subtitle2, Title } from "../../components/Typography/Typography"
import { Sortie } from "../../models/Sortie"
import { TimeUtilsDateFns } from "../../utils/TimeUtils"
import { useLocalStorageStore } from "../../zstore/LocalStorageStore"

interface SortieCardProps {
    sortie: Sortie
    setEditDialogSortie: (sortie: Sortie) => void
    sortieNumber: number
    required: boolean
}

export const SortieCard = (props: SortieCardProps) => {
    const { sortie, setEditDialogSortie, sortieNumber, required } = props
    const timeConvention = useLocalStorageStore((state) => state.timeConvention)

    return (
        <NexCard>
            <NexCardContent sx={{ height: "auto" }}>
                <Title disableGutter={true}>
                    Sortie #{sortieNumber}
                    {!sortie.id && <Chip label={"New"} color="info" size="small" sx={{ ml: 2, mt: -0.5 }} />}
                </Title>
                {required && <Subtitle2 disableGutter={true}>Required</Subtitle2>}
                <Stack sx={{ pt: 2 }}>
                    <BoldBody disableGutter={true}>Time in Air</BoldBody>
                    <Body>
                        Wheels Up Time:{" "}
                        {TimeUtilsDateFns.formatTime(sortie.fe_start_sortie, { format: timeConvention })}
                        <br />
                        Wheels Up Date: {TimeUtilsDateFns.formatDate(sortie.fe_start_sortie)} <br />
                    </Body>
                    <Body>
                        Wheels Down Time:{" "}
                        {TimeUtilsDateFns.formatTime(sortie.fe_stop_sortie, { format: timeConvention })}
                        <br />
                        Wheels Down Date: {TimeUtilsDateFns.formatDate(sortie.fe_stop_sortie)} <br />
                    </Body>

                    <BoldBody disableGutter={true}>Hobbs</BoldBody>
                    <Body disableGutter={true}>
                        Start: {sortie.start_hobbs} <br />
                        Stop: {sortie.stop_hobbs} <br />
                        Online: {sortie.active_hobbs} <br />
                        Mob: {sortie.mob_hobbs} <br />
                    </Body>
                </Stack>
            </NexCardContent>
            <CardActions sx={{ display: "flex", justifyContent: "right" }}>
                <NexCardActionButton variant="contained" onClick={() => setEditDialogSortie(sortie)}>
                    Edit
                </NexCardActionButton>
            </CardActions>
        </NexCard>
    )
}
